import { useState } from "react";
import VviConsumer from "./VviConsumer";

const useSendVviMail = () => {
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    const sendMail = (vnMail: string, vnName?: string, vnVorname?: string) => {
        setLoading(true);

        return VviConsumer.sendMail(vnMail, vnName, vnVorname)
            .then(succResp => {
                const succ = succResp === true;

                setError(!succ);
                return succ;

            }).catch(error => {
                setError(true);
                return false

            }).finally(() => {
                setLoading(false);
            });

    };


    return {
        loading,
        error,
        sendMail
    }
}

export default useSendVviMail;